var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenterElement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195",
    transform: "translate(-175 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "center_focus_strong_FILL0_wght400_GRAD0_opsz48",
    d: "M18.5,24.993A6.461,6.461,0,0,1,12.007,18.5,6.461,6.461,0,0,1,18.5,12.007,6.461,6.461,0,0,1,24.993,18.5,6.461,6.461,0,0,1,18.5,24.993Zm0-2.083a4.33,4.33,0,0,0,4.41-4.41,4.33,4.33,0,0,0-4.41-4.41,4.33,4.33,0,0,0-4.41,4.41,4.33,4.33,0,0,0,4.41,4.41ZM8.083,31A2.136,2.136,0,0,1,6,28.917V22.944H8.083v5.972h5.972V31Zm14.861,0V28.917h5.972V22.944H31v5.972A2.136,2.136,0,0,1,28.917,31ZM6,14.056V8.083A2.136,2.136,0,0,1,8.083,6h5.972V8.083H8.083v5.972Zm22.917,0V8.083H22.944V6h5.972A2.136,2.136,0,0,1,31,8.083v5.972ZM18.5,18.5Z",
    transform: "translate(179 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_507",
    "data-name": "Rectangle 507",
    width: 44,
    height: 44,
    transform: "translate(175 2)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterElement);
export default __webpack_public_path__ + "static/media/centerElement.5476fcf63cba69fb8c1597b2aee70e62.svg";
export { ForwardRef as ReactComponent };